import { render } from "./LoginPopup.vue?vue&type=template&id=618622b0&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=618622b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-618622b0"

export default script